import { http } from '../axios';
import { selectionlistConfig } from '../../config';

export const downloadCSV = (listId: string) => {
    return http.get(selectionlistConfig().endpointCSVDownload, {
        pathParams: { listId }
    });
};
